import { ReactNode } from 'react';
import { View } from 'react-native';
import { InfoIcon } from '../../Icons/InfoIcon';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';

export const InfoBox = ({
  className,
  title,
  subtitle,
  children,
}: {
  className?: string;
  title?: string;
  subtitle?: string;
  children?: ReactNode;
}) => {
  return (
    <View
      className={cn(
        'justify-center items-center bg-[#4F6FCD66] py-3 px-2 rounded-lg',
        className,
      )}>
      <View className="flex-row w-full">
        <View className="mt-[2px]">
          <InfoIcon fill="white" />
        </View>
        <View className="mx-2 flex-1 w-full">
          {children ?? (
            <>
              <Typography size="small" weight="bold">
                {title}
              </Typography>
              <Typography size="small">{subtitle}</Typography>
            </>
          )}
        </View>
      </View>
    </View>
  );
};
